import * as React from 'react'
import { Block } from '../Layout/Block'
import { Text } from '$views/components/Text'
import { StyledNumber, StyleDivision, StyledBlock } from './Step.style'

interface Props {
  label: string
  enable: boolean
  onSelectStep: (stepLabel: string) => void
  position: number
  stepsLabel: string[]
}

const getColor = (enable: boolean) => {
  if (enable) {
    return 'darkGrey'
  }
  return 'greyShadow'
}

const getTextColor = (enable: boolean) => {
  if (enable) {
    return 'darkGrey'
  }
  return 'grey'
}

export const Step: React.SFC<Props> = ({ enable, label, onSelectStep, stepsLabel, position }) => {
  const getStepNumber = () => {
    return stepsLabel.findIndex(value => value === label) + 1
  }

  const getTextWeight = () => {
    if (!enable) {
      return 'regular'
    }
    if (position + 1 !== getStepNumber()) {
      return 'regular'
    }
    return 'bold'
  }

  return (
    <StyledBlock enable={enable} onClick={() => onSelectStep(label)}>
      <Block flex justify="center">
        <StyledNumber enable={enable} color={getTextColor(enable)} weight={getTextWeight()}>
          {`${getStepNumber()}`}
        </StyledNumber>
      </Block>
      <Text weight={getTextWeight()} color={getTextColor(enable)} marginTop="base">
        {label}
      </Text>
      <StyleDivision color={getColor(enable)} marginTop="base" />
    </StyledBlock>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Step/Step.tsx